// eslint-disable-next-line ts/no-unsafe-function-type
export default function isFunction<T = Function>(argument: unknown): argument is T {
  return typeof argument === 'function';
}
